import { BannerTypes, createAdVariant } from './src';

export const SuperbannerAd = createAdVariant(
  'SuperbannerAd',
  BannerTypes.DESKTOP_BANNER_SINGLE_ANY
);

export const SkyscraperAd = createAdVariant(
  'SkyscraperAd',
  BannerTypes.DESKTOP_SKYSCRAPER_ANY
);

export const MediumRectangleAd = createAdVariant(
  'MediumRectangleAd',
  BannerTypes.DESKTOP_RECTANGLE_ANY
);

export const HalfPageAd = createAdVariant(
  'HalfPageAd',
  BannerTypes.DESKTOP_HPA_SINGLE_ANY
);

export const BillboardAd = createAdVariant(
  'BillboardAd',
  BannerTypes.DESKTOP_BANNER_BB_ANY_RL
);

export const SmartphoneBannerTop = createAdVariant(
  'SmartphoneBannerTop',
  BannerTypes.SMARTPHONE_BANNER_TOP
);

export const SmartphoneBannerAny = createAdVariant(
  'SmartphoneBannerAny',
  BannerTypes.SMARTPHONE_BANNER_ANY
);

export {
  AdProvider,
  AdStatus,
  setDemoAdsCookie,
  removeDemoAdsCookie,
} from './src';
